import { type AppRouter } from '@/server/api/root';
import { createTRPCClient, loggerLink, httpBatchLink } from '@trpc/client';
import SuperJSON from 'superjson';
import { checkSessionLink } from './links';

export const api = createTRPCClient<AppRouter>({
  links: [
    loggerLink({
      enabled: (op) => {
        // This is here to prevent logging errors when the request is aborted
        // @ts-expect-error signal is not typed, but it's a valid property
        if (op?.signal?.aborted) {
          return false;
        }
        return process.env.NODE_ENV === 'development';
      },
    }),
    checkSessionLink,
    httpBatchLink({
      transformer: SuperJSON,
      url: getBaseUrl() + '/api/trpc',
      headers: () => {
        const headers = new Headers();
        headers.set('x-trpc-source', 'nextjs-client');
        return headers;
      },
    }),
  ],
});

function getBaseUrl() {
  if (typeof window !== 'undefined') return window.location.origin;
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`;
  return `http://localhost:${process.env.PORT ?? 3000}`;
}
export type Api = typeof api;
